/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'locked': {
    viewBox: '0 0 32 32',
    data: `<path d="M24,13V9c0-4.4-3.6-8-8-8S8,4.6,8,9v4H5v18h22V13H24z M18,23c0,1.1-0.9,2-2,2s-2-0.9-2-2v-2c0-1.1,0.9-2,2-2s2,0.9,2,2V23zM22,13H10V9c0-3.3,2.7-6,6-6s6,2.7,6,6V13z"/>`
  }
})
